module.exports = __webpack_public_path__ + "img/plus_circle_yellow.svg";